import { OptimizelyProvider } from '@optimizely/react-sdk';
import {
    OptimizelyOverridesContext,
    OptimizelyOverrides
} from '../optimizelyOverrides';
import {
    OptimizelyOptions,
    getMockOptimizelyClient
} from './getMockOptimizelyClient';

export type { OptimizelyOptions };

const formatOverrides = (
    overrides?: OptimizelyOptions
): OptimizelyOverrides | undefined => {
    if (!overrides) return;
    const features =
        overrides.features?.reduce((acc, curr) => {
            acc[curr.feature] = curr.isEnabled;
            return acc;
        }, {} as Record<string, boolean>) || {};
    const experiments =
        overrides.experiments?.reduce((acc, curr) => {
            acc[curr.name] = curr.variation;
            return acc;
        }, {} as Record<string, string>) || {};
    return {
        features,
        experiments
    };
};

export const MockOptimizelyProvider: React.FC<{
    /** Mock values for genuine Optimizely client API calls */
    options?: OptimizelyOptions;
    /** Mock overrides values that bypass Optimizely client calls */
    overrides?: OptimizelyOptions;
}> = ({ options, overrides, children }) => (
    <OptimizelyProvider
        optimizely={getMockOptimizelyClient(options)}
        isServerSide={true}
    >
        <OptimizelyOverridesContext.Provider
            value={overrides ? formatOverrides(overrides) : undefined}
        >
            {children}
        </OptimizelyOverridesContext.Provider>
    </OptimizelyProvider>
);
